import React, { createContext, useContext } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import { useGetBusiness } from '../../../queries/business.queries';

interface PreviewContextProps {
  isPreviewMode: boolean;
  hasPreviewParam: boolean;
}

export const PreviewModeContext = createContext<PreviewContextProps>({
  isPreviewMode: false,
  hasPreviewParam: false,
});

interface PreviewProviderProps {
  children: React.ReactNode;
}

export function PreviewModeContextProvider({ children }: PreviewProviderProps) {
  const [searchParam] = useSearchParams();

  let { id } = useParams();
  const { data } = useGetBusiness(id);

  const previewParam = searchParam.get('preview');

  const isPreviewMode = previewParam && previewParam === data?.id;

  return (
    <PreviewModeContext.Provider
      value={{
        isPreviewMode,
        hasPreviewParam: Boolean(previewParam),
      }}
    >
      {children}
    </PreviewModeContext.Provider>
  );
}

export const usePreviewModeContext = () => {
  return useContext(PreviewModeContext);
};
